import type {MetropolisConfiguration} from '@nlabs/metropolisjs';

const reaktorEventEndpoint = 'https://events.reaktor.io/track';
const reaktorAnalyticsId = '9892dc86-28c2-47d5-aed9-c8ceb6ac1ba6';

const metropolisEnvironment = {
  app: {
    api: {
      rum: reaktorEventEndpoint
    },
    name: 'ufat',
    rum: {
      analyticsId: reaktorAnalyticsId,
      enabled: true
    }
  }
} satisfies NonNullable<MetropolisConfiguration['production']>;

export const metropolisConfig: MetropolisConfiguration = {
  development: {
    ...metropolisEnvironment,
    environment: 'development'
  },
  local: {
    ...metropolisEnvironment,
    environment: 'local'
  },
  production: {
    ...metropolisEnvironment,
    environment: 'production'
  },
  test: {
    ...metropolisEnvironment,
    environment: 'test'
  }
};
